module.exports = __webpack_public_path__ + "static/car2-83edb4913a5e778048a2600e017feba6.jpg";